// src/services/LocationService.ts
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  addDoc,
  deleteDoc,
  query,
  where,
  Timestamp,
} from "firebase/firestore";
import { Location } from "@visitproof/types";
import { db } from "../firebase";
import { clean } from "../utils/utils";

const locationCollectionRef = collection(db, "locations");

export const LocationService = {
  async createLocation(
    locationData: Omit<Location, "id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const newLocation: Omit<Location, "id"> = {
      ...locationData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    };

    const locationRef = await addDoc(locationCollectionRef, newLocation);
    return locationRef.id;
  },

  async getLocation(locationId: string): Promise<Location | null> {
    const locationDoc = await getDoc(doc(locationCollectionRef, locationId));
    if (locationDoc.exists()) {
      return { id: locationDoc.id, ...locationDoc.data() } as Location;
    }
    return null;
  },

  async getAllLocations(accountId: string): Promise<Location[]> {
    const locationSnapshot = await getDocs(
      query(locationCollectionRef, where("accountId", "==", accountId)),
    );
    return locationSnapshot.docs.map(
      (doc) => ({ id: doc.id, ...doc.data() }) as Location,
    );
  },

  async updateLocation(
    locationId: string,
    updatedData: Partial<Omit<Location, "id" | "createdAt">>,
  ): Promise<void> {
    const locationDocRef = doc(locationCollectionRef, locationId);
    await updateDoc(locationDocRef, clean({
      ...updatedData,
      updatedAt: Timestamp.now(),
    }));
  },

  async deleteLocation(locationId: string): Promise<void> {
    const locationDocRef = doc(locationCollectionRef, locationId);
    await deleteDoc(locationDocRef);
  },
};
